module.exports = __webpack_public_path__ + "static/media/day27_photoedit.c3ddf2f3.gif";